<template>
  <Modal
    v-model="modalVisible"
    title="修改用户名"
    @on-ok="handleOk"
    @on-cancel="cancel"
  >
    <div class="modal-content">
      <span>请输入用户名：</span>
      <Input
        v-model.trim="value"
        placeholder="请输入用户名"
        style="width: 200px"
        @on-change="handleChange"
      />
    </div>
  </Modal>
</template>
<script>
import { saveLoginUser } from "../../utils/localStorage";
import { siteMixin } from "../../utils/mixin.js";
import { user } from "../../request";
export default {
  mixins: [siteMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: "",
    };
  },
  computed: {
    modalVisible: {
      get() {
        return this.visible; // 读取 prop
      },
      set(newVal) {
        this.$emit("update:visible", newVal); // 写入时触发事件
      },
    },
  },
  methods: {
    handleChange(event) {
      this.value = this.value.replace(/\s+/g, "");
    },
    cancel() {
      this.modalVisible = false;
    },
    async handleOk() {
      if (!this.value) {
        this.$message.error("请输入用户名");
        return;
      }
      // 匹配18位或15位身份证号（宽松版）
      const idCardRegex = /\d{17}[\dXx]|\d{15}/;
      if (idCardRegex.test(this.value)) {
        this.$message.error("用户名不允许含有身份证号");
        return;
      }

      // 检查字符串中是否包含11位手机号
      const containsPhoneRegex = /1[3-9]\d{9}/;
      if (containsPhoneRegex.test(this.value)) {
        this.$message.error("用户名不允许含有手机号");
        return;
      }

      const params = {
        username: this.value,
        userId: this.loginUser.userId,
      };
      const data = await user.updateUserName(params);
      if (data.status === 1) {
        const userInfo = data.data;
        this.setUserLogin(userInfo);
        saveLoginUser(userInfo);
        this.$message.success("修改用户名成功");
      } else {
        this.$Message.error(data.message);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.modal-content {
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 300px;
  height: 100px;
}
</style>
